module.exports = __webpack_public_path__ + "static/media/light_fixture.c5a04417.jpg";